import { useEffect, useState, } from 'react';
import moment from 'moment';

import { Container, Grid, } from '@material-ui/core';
import { Notification, } from 'rsuite';

import {
  listTickets,
  listCompanies,
  listBackupAlerts,
  listMonitoring,
  getTicketYearlySummary,
  getTicketMonthlySummary,
} from '../../services/api';
import { asList, } from '../../services/list';

import NavBar from '../../components/NavBar/NavBar';
import OverviewPanel from '../../components/OverviewPanel';
import TicketsPerTypeTable from '../../components/TicketsPerTypeTable';
import TicketsTable from '../../components/TicketsTable';
import NewTicketFAB from '../../components/NewTicketFAB';
import DateIntervalSelector from '../../components/DateIntervalSelector';

import './styles.css';

import { isServerAlertActive, } from '../../entities/server';
import { hasExpiringHours, } from '../../entities/company';
import { TicketStatus, } from '../../entities/ticket';


function Chamados() {
  const [natureza, setNatureza] = useState([])
  const [year, setYear] = useState([])
  const [alertas, setAlertas] = useState([])

  const [tickets, setTickets] = useState([]);
  const openTickets = tickets.filter(({ status, }) => TicketStatus.OPEN === status);

  const [mon, setMon] = useState([]);
  const serversWithError = mon.filter(isServerAlertActive);

  const [bodyEmp, setBodyEmp] = useState([]);
  const clientsWithExpiringHours = bodyEmp.filter(hasExpiringHours);


  async function getData() {
    try {
      await Promise.all([
        listBackupAlerts().then(({ data }) => {
          setAlertas(asList(data));
        }),
        getTicketMonthlySummary().then(({ data }) => {
          setNatureza(asList(data));
        }),
        getTicketYearlySummary().then(({ data }) => {
          setYear(asList(data));
        }),
        getTickets(),
        listCompanies(true).then(({ data }) => {
          setBodyEmp(asList(data));
        }),
        listMonitoring().then(({ data }) => {
          setMon(asList(data));
        }),
      ]);
    } catch (err) {
      Notification['error']({
        placement: 'bottomEnd',
        title: 'Erro ao carregar os chamados',
        description: 'Não foi possível carregar todos os dados.',
      });
    }
  }

  async function getTickets(startDate, endDate) {
    const { data, } = await listTickets(startDate, endDate);
    setTickets(asList(data));
  }

  useEffect(() => {
    getData();
  }, []);


  return (
    <NavBar>
      <Container
        style={{
          paddingLeft: 0,
          paddingRight: 0,
        }}
        maxWidth="xl"
      >
        <div className="WelcomeUsers">
          Chamados
        </div>
        <Grid
          container
          spacing={1}
        >
          <OverviewPanel
            backupAlertsCount={alertas.length}
            openTicketsCount={openTickets.length}
            clientsWithExpiringHoursCount={clientsWithExpiringHours.length}
            serversWithErrorCount={serversWithError.length}
          />

          <Grid
            item
            xs={12}
            sm={6}
          >
            <h5 className="TitleChamados">
              Últimos chamados
            </h5>

            <DateIntervalSelector onSubmit={({start, end, } ) => getTickets(start, end)} />

            <TicketsTable tickets={tickets} />
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
          >
            <div className="Periodo">
              <h5 className="TitleChamados">
                Indicadores dos últimos 30 dias
              </h5>
              <span>
                Período {moment().subtract(30, 'days').format('L')} -{' '}
                {moment().format('L')}
              </span>
            </div>

            <TicketsPerTypeTable items={natureza} />

            <Grid
              style={{
                marginTop: '10px',
              }}
              item
              xs={12}
              sm={12}
            >
              <div className="Periodo">
                <h5 className="TitleChamados">
                  No acumulado do ano
                </h5>
                <span>
                  Período {moment().subtract(1, 'year').format('L')} -{' '}
                  {moment().format('L')}
                </span>
              </div>

              <TicketsPerTypeTable items={year} />
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <br />

      <NewTicketFAB />
    </NavBar>
  );
}

export default Chamados;
